/* DEINSPAR | Classic variant picker for Maps, Personalised and Frames.
 * The editorial poster picker is intentionally excluded.
 * Shopify's native variant radios and existing personalised editor remain the source of truth.
 */
(function () {
  'use strict';
  var MOBILE = '(max-width: 768px)';

  function mobile() { return window.matchMedia(MOBILE).matches; }
  function norm(value) { return String(value || '').trim(); }
  function getNative(picker) {
    return picker.querySelector('.custom-variant-picker__native variant-radios-detail, .custom-variant-picker__native variant-group-detail');
  }
  function nativeOptions(picker, index) {
    var root = getNative(picker);
    if (!root) return [];
    var fields = root.querySelectorAll('fieldset.product-form__input');
    return fields[index] ? Array.from(fields[index].querySelectorAll('input[type="radio"]')) : [];
  }
  function getSelected(picker, index) {
    var options = nativeOptions(picker, index);
    var chosen = options.find(function (item) { return item.checked; });
    if (chosen) return norm(chosen.value);
    var root = getNative(picker);
    var fields = root ? root.querySelectorAll('fieldset.product-form__input') : [];
    var visible = fields[index] && fields[index].querySelector('.option_drop_value .option_value, .form__label .option_value');
    return norm(visible && visible.textContent);
  }
  function selectNative(picker, index, value) {
    var target = nativeOptions(picker, index).find(function (el) { return norm(el.value) === norm(value); });
    if (!target || target.disabled || target.classList.contains('option-disabled')) return false;
    if (!target.checked) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }
  function variants(picker) {
    var root = getNative(picker);
    var script = root && root.querySelector('script[type="application/json"]');
    try { return script ? JSON.parse(script.textContent) : []; }
    catch (e) { return []; }
  }
  function formatMoney(cents) {
    var curr = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var value = Number(cents) / 100;
    if (!Number.isFinite(value)) return '';
    try {
      if (curr === 'EUR') return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value) + ' €';
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: curr }).format(value);
    } catch (e) { return value.toFixed(2).replace('.', ',') + ' ' + curr; }
  }
  // Only correct the visible format on classic products whose original
  // Liquid-rendered Euro price uses a decimal comma and suffix currency.
  // The theme's variant update sometimes renders "€29.95" after selection,
  // although Shopify's initial price was "19,95 €". Do not alter prices,
  // variant IDs, product data, checkout or other currencies.
  function preserveOriginalEuroPriceStyle(picker) {
    var product = picker.closest('.product__item-js');
    var priceRoot = product && product.querySelector('.product-detail__price');
    if (!priceRoot) return;
    var startingPrice = priceRoot.querySelector('.card-product-price .price');
    if (!startingPrice || !/\d[,.]\d{2}\s*€/.test(startingPrice.textContent || '')) return;

    function convertPrefixAmount(raw) {
      var text = String(raw).replace(/[\s\u00a0\u202f]/g, '');
      var decimal = Math.max(text.lastIndexOf(','), text.lastIndexOf('.'));
      var hasDecimals = decimal >= 0 && text.length - decimal - 1 === 2;
      var integerPart = hasDecimals ? text.slice(0, decimal) : text;
      var fraction = hasDecimals ? text.slice(decimal + 1) : '00';
      var whole = integerPart.replace(/[.,]/g, '');
      if (!/^\d+$/.test(whole) || !/^\d{2}$/.test(fraction)) return null;
      var cents = Number(whole) * 100 + Number(fraction);
      if (!Number.isSafeInteger(cents)) return null;
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100) + ' €';
    }
    function formatVisiblePrices() {
      priceRoot.querySelectorAll('.card-product-price .price, .card-product-price .compare-price').forEach(function (el) {
        if (el.children.length) return;
        var before = el.textContent || '';
        var after = before.replace(/€\s*([0-9][0-9.,\s\u00a0\u202f]*)/g, function (match, raw) {
          return convertPrefixAmount(raw) || match;
        });
        if (after !== before) el.textContent = after;
      });
    }
    var priceObserver = new MutationObserver(formatVisiblePrices);
    priceObserver.observe(priceRoot, { childList: true, characterData: true, subtree: true });
    formatVisiblePrices();
  }

  function makeSheet(className, title) {
    var shell = document.createElement('div');
    shell.className = 'ds-classic-frame-sheet';
    shell.hidden = true;
    shell.innerHTML = '<button class="ds-classic-frame-sheet__overlay" type="button" data-ds-classic-close aria-label="Schließen"></button>' +
      '<div class="ds-classic-frame-sheet__panel" role="dialog" aria-modal="true" aria-label="' + escapeHtml(title) + '">' +
        '<div class="ds-classic-frame-sheet__handle"></div>' +
        '<div class="ds-classic-frame-sheet__header"><span class="ds-classic-frame-sheet__title"></span>' +
          '<button type="button" class="ds-classic-frame-sheet__close" aria-label="Schließen" data-ds-classic-close>&times;</button></div>' +
        '<div class="ds-classic-frame-sheet__content"></div>' +
      '</div>';
    shell.querySelector('.ds-classic-frame-sheet__title').textContent = title;
    document.body.appendChild(shell);
    return shell;
  }
  function escapeHtml(t) {
    return String(t || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }
  function setupPicker(picker) {
    if (picker.dataset.deinsparClassicReady === '1' || picker.hasAttribute('data-deinspar-visual-picker')) return;
    var native = getNative(picker);
    var size = picker.querySelector('[data-custom-size-picker]');
    var sizeTrigger = picker.querySelector('[data-custom-size-trigger]');
    if (!native || !size || !sizeTrigger) return;

    var productRoot = picker.closest('.product__item-js');
    var isPersonalised = Boolean(productRoot && productRoot.querySelector('[data-personalised-modal]')) ||
      Boolean(document.querySelector('[data-personalised-modal]'));

    picker.dataset.deinsparClassicReady = '1';
    picker.setAttribute('data-deinspar-classic-picker', '');
    var dropdown = picker.querySelector('[data-custom-size-dropdown]');
    var sheet = picker.querySelector('[data-custom-size-sheet]');
    var sizeText = picker.querySelector('[data-custom-size-trigger-text]');
    var sizeOptions = Array.from(picker.querySelectorAll('[data-custom-size-value]'));
    var frame = picker.querySelector('[data-custom-frame-picker]');
    var frameGrid = frame && frame.querySelector('.custom-frame-picker__grid');
    var frameCards = frameGrid ? Array.from(frameGrid.querySelectorAll('[data-custom-frame-value]')) : [];
    var allVariants = variants(picker);

    // The classic size bottom-sheet must escape sticky/overflow containers.
    if (sheet && sheet.parentElement !== document.body) document.body.appendChild(sheet);

    function syncSize() {
      var value = getSelected(picker, 0);
      if (sizeText && value) sizeText.textContent = value;
      sizeOptions.forEach(function (option) {
        var selected = norm(option.dataset.customSizeValue) === value;
        option.classList.toggle('is-active', selected);
        option.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      syncFrame();
    }
    function openSize() {
      if (!size) return;
      closeFrame();
      size.classList.add('is-open');
      sizeTrigger.setAttribute('aria-expanded', 'true');
      if (mobile()) {
        if (dropdown) dropdown.hidden = true;
        if (sheet) sheet.hidden = false;
        document.body.classList.add('custom-size-sheet-open');
      } else {
        if (dropdown) dropdown.hidden = false;
        if (sheet) sheet.hidden = true;
      }
    }
    function closeSize() {
      size.classList.remove('is-open');
      sizeTrigger.setAttribute('aria-expanded', 'false');
      if (dropdown) dropdown.hidden = true;
      if (sheet) sheet.hidden = true;
      document.body.classList.remove('custom-size-sheet-open');
    }
    if (!isPersonalised) {
      sizeTrigger.addEventListener('click', function () {
        if (size.classList.contains('is-open')) closeSize(); else openSize();
      });
      sizeOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          if (option.disabled || option.classList.contains('is-disabled')) return;
          if (!selectNative(picker, 0, option.dataset.customSizeValue)) return;
          closeSize();
          syncSize();
          window.setTimeout(syncSize, 120);
        });
      });
      picker.querySelectorAll('[data-custom-size-close]').forEach(function (button) {
        button.addEventListener('click', closeSize);
      });
      if (sheet) sheet.querySelectorAll('[data-custom-size-close]').forEach(function (button) {
        button.addEventListener('click', closeSize);
      });
    }

    // For Maps + Personalised, reuse the SAME frame cards in a mobile bottom-sheet.
    // Do not duplicate the cards: personalised.js listeners and price updates stay intact.
    var frameTrigger = null;
    var frameSheet = null;
    var originalParent = frameGrid && frameGrid.parentNode;
    var originalNext = frameGrid && frameGrid.nextSibling;
    if (frameGrid && frameCards.length) {
      frameTrigger = document.createElement('button');
      frameTrigger.type = 'button';
      frameTrigger.className = 'ds-classic-frame-trigger';
      frameTrigger.setAttribute('aria-expanded', 'false');
      frameTrigger.innerHTML = '<span class="ds-classic-frame-trigger__label"></span>' +
        '<span class="ds-classic-frame-trigger__value"></span>' +
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="m3 4.5 3 3 3-3" stroke="currentColor" stroke-width="1.3"/></svg>';
      frameTrigger.querySelector('.ds-classic-frame-trigger__label').textContent = norm(frame.querySelector('.custom-frame-picker__title')?.textContent) || 'Bilderrahmen';
      frame.insertBefore(frameTrigger, frameGrid);
      frameSheet = makeSheet('ds-classic-frame-sheet', frameTrigger.querySelector('.ds-classic-frame-trigger__label').textContent);
      frameTrigger.addEventListener('click', function () {
        if (frameSheet.hidden) openFrame(); else closeFrame();
      });
      frameSheet.querySelectorAll('[data-ds-classic-close]').forEach(function (button) {
        button.addEventListener('click', closeFrame);
      });
      frameCards.forEach(function (card) {
        card.addEventListener('click', function () {
          if (!card.disabled) {
            // Personalised owns its frame selections; Maps uses Shopify's variants.
            if (!isPersonalised && !selectNative(picker, 1, card.dataset.customFrameValue)) return;
            syncFrame(card.dataset.customFrameValue);
            closeFrame();
            window.setTimeout(syncFrame, 130);
          }
        });
      });
    }
    function syncFrame(forcedValue) {
      if (!frameCards.length) return;
      var value = forcedValue || getSelected(picker, 1);
      var card = frameCards.find(function (c) { return norm(c.dataset.customFrameValue) === value; });
      if (frameTrigger) {
        frameTrigger.querySelector('.ds-classic-frame-trigger__value').textContent = card ?
          norm(card.querySelector('.custom-frame-card__title')?.textContent) : (value || '');
      }
      frameCards.forEach(function (item) {
        item.classList.toggle('is-active', norm(item.dataset.customFrameValue) === value);
      });
      if (!isPersonalised) updateFramePrices();
    }
    function updateFramePrices() {
      if (!frameCards.length || !allVariants.length) return;
      var selectedSize = getSelected(picker, 0);
      var subset = allVariants.filter(function (v) { return norm(v.option1) === selectedSize; });
      if (!subset.length) return;
      var none = subset.find(function (v) { return /ohne rahmen|without frame|no frame|sans cadre|uten ramme|uden ramme|senza cornice|sin marco|utan ram|zonder/i.test(norm(v.option2)); });
      var baseline = none ? Number(none.price || 0) : 0;
      var compareBase = none ? Number(none.compare_at_price || none.price || 0) : 0;
      frameCards.forEach(function (card) {
        var v = subset.find(function (variant) { return norm(variant.option2) === norm(card.dataset.customFrameValue); });
        var price = card.querySelector('[data-frame-card-price]');
        if (!v || !price) return;
        var extra = Math.max(0, Number(v.price || 0) - baseline);
        price.textContent = (extra ? '+' : '') + formatMoney(extra);
        var compare = card.querySelector('.ds-classic-frame-compare');
        var compareExtra = Number(v.compare_at_price || v.price || 0) - compareBase;
        if (compareExtra > extra) {
          if (!compare) {
            compare = document.createElement('span');
            compare.className = 'ds-classic-frame-compare';
            price.insertAdjacentElement('afterend', compare);
          }
          compare.textContent = '+' + formatMoney(compareExtra);
          price.classList.add('is-sale');
        } else {
          if (compare) compare.remove();
          price.classList.remove('is-sale');
        }
      });
    }
    function openFrame() {
      if (!frameSheet || !frameGrid || !mobile()) return;
      if (!isPersonalised) closeSize();
      frameSheet.querySelector('.ds-classic-frame-sheet__content').appendChild(frameGrid);
      frameSheet.hidden = false;
      frameTrigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ds-classic-frame-open');
    }
    function closeFrame() {
      if (!frameSheet) return;
      frameSheet.hidden = true;
      frameTrigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ds-classic-frame-open');
      if (frameGrid && originalParent && frameGrid.parentElement !== originalParent) {
        if (originalNext && originalNext.parentNode === originalParent) originalParent.insertBefore(frameGrid, originalNext);
        else originalParent.appendChild(frameGrid);
      }
    }
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeFrame();
      if (!isPersonalised) closeSize();
    });
    document.addEventListener('click', function (event) {
      if (!mobile() && !isPersonalised && !size.contains(event.target) && !dropdown?.contains(event.target)) closeSize();
    });
    window.addEventListener('resize', function () {
      if (!isPersonalised) closeSize();
      closeFrame();
    }, { passive: true });
    native.addEventListener('change', function () { window.setTimeout(syncSize, 0); });
    document.addEventListener('variant:change', function () { window.setTimeout(syncSize, 0); });
    if (!isPersonalised && frameCards.length === 0) preserveOriginalEuroPriceStyle(picker);
    window.setTimeout(syncSize, 0);
  }

  function boot() {
    document.querySelectorAll('.custom-variant-picker:not([data-deinspar-visual-picker])').forEach(setupPicker);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
